export interface DiagnosticEntry {
  time: string;
  level: "info" | "warning" | "error";
  event: string;
  detail?: string;
}

const STORAGE_KEY = "pindou:diagnostics:v1";
const MAX_ENTRIES = 200;

export function readDiagnostics(): DiagnosticEntry[] {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "[]");
    return Array.isArray(value) ? value.slice(-MAX_ENTRIES) : [];
  } catch { return []; }
}

export function logDiagnostic(level: DiagnosticEntry["level"], event: string, detail?: string): void {
  try {
    const entries = readDiagnostics();
    entries.push({ time: new Date().toISOString(), level, event, detail: detail?.slice(0, 500) });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(-MAX_ENTRIES)));
  } catch { /* diagnostics must never interrupt project work */ }
}

export function diagnosticsBlob(): Blob {
  const report = {
    format: "pindou-diagnostics-v1",
    generatedAt: new Date().toISOString(),
    userAgent: navigator.userAgent,
    entries: readDiagnostics(),
    privacy: "此文件不包含导入图片、单元格数据或项目备份。",
  };
  return new Blob([JSON.stringify(report, null, 2)], { type: "application/json" });
}
